import React from "react";
import { ShieldCheck, Headphones, Zap, Link2, Trophy, Lock } from "lucide-react";

const features = [
    {
        icon: ShieldCheck,
        title: "Keamanan Tingkat Tinggi",
        desc: "Enkripsi SSL 256-bit, proteksi anti-DDoS, dan audit keamanan berkala menjadikan PUSATCUAN situs hiburan online terpercaya di Indonesia.",
        span: "md:col-span-7",
    },
    {
        icon: Headphones,
        title: "Layanan 24/7",
        desc: "CS profesional siap membantu kapan saja.",
        span: "md:col-span-5",
    },
    {
        icon: Zap,
        title: "Transaksi Kilat",
        desc: "Deposit & withdraw di bawah 3 menit.",
        span: "md:col-span-5",
    },
    {
        icon: Link2,
        title: "Akses Link Resmi Terpercaya",
        desc: "Multi-link alternatif anti-blokir untuk akses lancar ke pusatcuan slot dan seluruh game online terbaru.",
        span: "md:col-span-7",
    },
    {
        icon: Trophy,
        title: "Bonus & Promo Premium",
        desc: "Penawaran eksklusif setiap hari.",
        span: "md:col-span-4",
    },
    {
        icon: Lock,
        title: "Privasi Terjamin",
        desc: "Data member tidak dibagikan ke pihak ketiga.",
        span: "md:col-span-4",
    },
    {
        icon: Trophy,
        title: "Provider Lisensi Resmi",
        desc: "Bermitra dengan provider top dunia.",
        span: "md:col-span-4",
    },
];

export default function Features() {
    return (
        <section
            id="tentang"
            data-testid="features-section"
            className="relative py-24 md:py-32"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="max-w-3xl">
                    <span className="text-xs tracking-[0.25em] uppercase text-[#D4AF37]">
                        Mengapa PUSATCUAN
                    </span>
                    <h2
                        data-testid="features-title"
                        className="mt-4 text-3xl md:text-5xl font-medium tracking-tighter text-white"
                    >
                        Dibangun untuk menjadi{" "}
                        <span className="text-gold-gradient">situs hiburan no 1 Indonesia</span>
                    </h2>
                    <p className="mt-5 text-white/60 text-base md:text-lg leading-relaxed max-w-2xl">
                        Kami memadukan teknologi, keamanan, dan layanan premium untuk
                        memberi Anda akses tanpa hambatan ke platform hiburan digital
                        terbaik dengan link resmi terpercaya.
                    </p>
                </div>

                <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
                    {features.map((f, i) => {
                        const Icon = f.icon;
                        return (
                            <article
                                key={f.title}
                                data-testid={`feature-card-${i}`}
                                className={`${f.span} group relative overflow-hidden rounded-2xl bg-[#0c0c0c] border border-white/5 p-8 hover:border-[#D4AF37]/40 transition-all duration-300 hover:-translate-y-1`}
                            >
                                <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(212,175,55,0.08),transparent_60%)] opacity-0 group-hover:opacity-100 transition-opacity" />
                                <div className="relative">
                                    <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[#D4AF37]/10 border border-[#D4AF37]/30 text-[#D4AF37]">
                                        <Icon size={22} />
                                    </div>
                                    <h3 className="mt-6 text-xl md:text-2xl font-medium text-white">
                                        {f.title}
                                    </h3>
                                    <p className="mt-3 text-white/60 leading-relaxed">
                                        {f.desc}
                                    </p>
                                </div>
                            </article>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
